@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-datepicker'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="invalid()">
    </form-label>
}

<p-datePicker
    [inputId]="id() + '-datepicker'"
    [(ngModel)]="value"
    [selectionMode]="selectionMode()"
    [readonlyInput]="readonlyInput()"
    [showClear]="showClear()"
    [showButtonBar]="showButtonBar()"
    [showIcon]="true"
    [placeholder]="placeholder() | translate"
    [appendTo]="'body'"
    [fluid]="true"
    [size]="size()"
    [iconDisplay]="'input'"
    [maxDate]="maxDateTodayUTC() ? endOfCurrentDayUTC : maxDate()"
    [disabled]="disabled()"
    (onClear)="onClear()"
    (onClearClick)="onClear()"
    (onShow)="onOpen()"
    (onClose)="onClose()"></p-datePicker>
